<template>
    <div class="main">
        <div class="content-container">
            <div class="content-head">
                <div class="content-head-body">
                    <span>
                        <img class="website-logo" src="/static/img/zhuhai/珠西logo.svg" alt="" @click="gotoIndex">
                        <img class="website-logo" src="/static/img/zhuhai/省平台logo.svg" alt="" style="margin-left: 5px;" @click="gotoIndex">
                    </span>
                    <span>
                         <span class="menu-item" :class="{menuActive:active==item.navCode}"
                               v-for="(item, index) in menuList">
                            <a href="javascript:void(0);" @click="gotoUrl(item)">{{ item.navName }}</a>
                         </span>
                    </span>
                </div>


            </div>
            <router-view v-slot="{ Component }">
                <keep-alive>
                    <component :is="Component" v-if="$route.meta.keepAlive"/>
                </keep-alive>
                <component :is="Component" v-if="!$route.meta.keepAlive"/>
            </router-view>
        </div>
        <div class="footer">
            <div class="content color-content" style="padding-top: 15px;padding-bottom: 15px;">
                <div class="copy-right">版权所有：<a href="https://www.gdcc.com.cn/" target="_blank">广东省科技基础条件平台中心</a> &nbsp; | &nbsp; <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备05020792-3</a> &nbsp;&nbsp;&nbsp;&nbsp; <img class="" style="height: 15px;width: 15px;position: relative;top: 3px;" src="@static/img/police-logo.png"/><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402000497" target="_blank" >粤公网安备 44010402000497号</a></div>
                <div class="address">地址：<a href="https://map.qq.com/?what=%E5%B9%BF%E4%B8%9C%E7%9C%81%E5%B9%BF%E5%B7%9E%E5%B8%82%E8%BF%9E%E6%96%B0%E8%B7%AF171&city=%E5%B9%BF%E5%B7%9E%E5%B8%82&type=poi&ref=DFPBZ-TE23D-HHD4G-PY4TF-VE27J-HYBWQ" target="_blank">广东省广州市越秀区连新路171号3号楼</a> &nbsp; | &nbsp; 电话：<a href="tel:020-83163463">020-83163463</a>   </div>
            </div>
        </div>

        <!--        <Footer class="bottom-element"></Footer>-->
    </div>
</template>

<script setup>
import Head from '../../components/common/Head'
import Menu from '../../components/common/Menu'
import Footer from '../../components/common/Footer'
import { useRoute } from 'vue-router'
import {getCurrentInstance, onMounted, ref,watch} from 'vue';
const {proxy} = getCurrentInstance();


console.log('设置站点类型')
// 设置分站标识为 'zhuhai'
proxy.$store.commit('setSiteType', {siteType: 'zhuhai'});
console.log('当前站点标识：', proxy.$store.state.siteType)


const active = ref('index');
const menuList = ref([]);

const gotoUrl = (item) => {
    if(item.navCode === 'logoutFunc'){
        //退出登录
        gotoLogout();
    }else{
        active.value = item.navCode;
        proxy.$router.push({path: item.navCode});
    }


}

const gotoIndex = () => {
    proxy.$router.push({path: '/zhuhai/index'});
}

//退出登录
const gotoLogout = () => {
    proxy.$http.post('/core/base/c/index/logout').then(res => {
        if (res.data.state == 0) {
            proxy.$store.commit('updateLoginStatus', {token: ''});
            proxy.$store.commit('updateUserInfo', {userInfo: '{}'});

            // 获取分站类型
            const siteType = proxy.$store.state.siteType;
            if(siteType == proxy.$enumVals.SiteTypeEnum.ZHUHAI.type){
                // 跳转至珠海
                proxy.$router.push({name: 'ZhuhaiMain', path: '/zhuhai'});
            }else if(siteType == proxy.$enumVals.SiteTypeEnum.ZHAOQING.type){
                // 跳转至肇庆
                proxy.$router.push({name: 'ZhaoqingMain', path: '/zhaoqing'});
            }else{
                proxy.$router.push({name: 'Index', path: '/'});
            }
            setTimeout(function () {
                window.location.reload();
            }, 100);
            // location.reload();
        }
    }).catch(err => {

    });
}


//设置菜单最后两项，若已登录，显示跳转我的控制台和退出登录菜单，若未登录显示登录和注册
const setLoginMenu = () => {
    menuList.value = [
        {
            navCode: '/zhuhai/index',
            navName: '首页'
        },
        {
            navCode: '/zhuhai/resRetrieve',
            navName: '科研仪器'
        },
        {
            navCode: '/zhuhai/zhuhaiPlatform',
            navName: '实验室与平台基地'
        },
        {
            navCode: '/zhuhai/zhuhaiAbout',
            navName: '关于我们'
        },
    ];
    if (proxy.$store.state.userInfo && proxy.$store.state.userInfo.userName) {
        //已登录
        menuList.value.push(
            {
                navCode: '/zhuhai/zhuhaiUser',
                navName: '我的控制台'
            },
            {
                navCode: 'logoutFunc',
                navName: '退出登录'
            }
        );
    }else{
        //未登录
        menuList.value.push(
            {
                navCode: '/zhuhai/zhuhaiLogin',
                navName: '登录'
            },
            {
                navCode: '/zhuhai/zhuhaiRegister',
                navName: '注册'
            }
        );
    }

}

onMounted(()=>{


    setLoginMenu();
})

const route = useRoute() // 获取当前路由对象
// 监听路由变化：只要路由跳回当前页面，就执行
watch(
    () => route.path, // 监听路由路径
    () => {
        setLoginMenu();
    },
    { immediate: false } // 不需要立即执行，首次已经由onMounted执行
)


</script>

<style scoped lang="less">
.main {
    width: 100%;
    height: 100vh;
    /* 设置父元素为flex布局, 实现《页面高度不足时，在底部显示；页面高度超出时，随页面滚动》 */
    display: flex;
    /* 设置子元素的排列方向为垂直 */
    flex-direction: column;
    /* 设置子元素在该方向上的对齐方式 */
    justify-content: space-between;

    background-color: #F6F9FF;
}
.content-container{
    background-image: url('/static/img/zhuhai/顶部图片背景-大.svg');
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: 0px 55px;
    background-color: #F6F9FF;
}
.menu-item {
    //height: 100%;
    padding: 14px 10px;
}

.menuActive {
    border-bottom: 3px solid #fff;

}

.menu-item a {
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #fff;
    letter-spacing: 0;
    text-align: justify;
    text-decoration: none;


}

.menu-item.active a {
    color: #fff;
}

.menu-item a:hover {
    color: #ccc;
}

.content-head {
    height: 55px;
    background-color: #1B66FC;
    display: flex;
    justify-content: center;
}
.content-head-body{
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.website-logo:hover{
    cursor: pointer;
}
.color-content{
    background:  #E3E4E5;
}
.footer{
    width: 100%;
    height: 200px;
    background:  #E3E4E5;
}
.copy-right,.address{
    font-family: SourceHanSansCN-Regular;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    letter-spacing: 0;
    text-align: center;
}
.address{
    margin-top: 8px;
}
.footer-content{
    padding-top: 19px;
    display: flex;
}
.footer-qrcode,.about,.friend-link{
    display: inline-block;
}
.footer-qrcode{
    margin-left: 130px;
}
.footer-qrcode img{
    width: 98px;
    height: 98px;
}
.about{
    margin-left: 39px;
}
.friend-link{
    margin-left: 150px;
}
.about .footer-text{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.footer-title{
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    letter-spacing: 0;
    text-align: start;
    line-height: 30px;

}
.footer-text, .footer-text .link-text{
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: rgba(0,0,0,0.50);
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    text-decoration: none;
}
.link-text{
    display: inline-block;
}
.link-text:visited,.link-text:active{
    color: rgba(0,0,0,0.50);
}
.link-text:hover{
    color:rgba(0,0,0,0.90);;
}
.friend-link .footer-text{
    display: table;
}
.footer-row{
    display: table-row;
}
.footer-row .link-text{
    display: table-cell;
    text-align: left;
}
.footer-row>:first-child{
    padding-right: 40px;
}
</style>

